import { makeAutoObservable, runInAction } from 'mobx';

/**
 * Optimistisches Flag für laufende EventJobs.
 *
 * `eventsApi` setzt beim Auslösen eines Jobs (createEvents*) sofort `markStarted()`,
 * damit `isEventJobRunning` ohne die bis zu 5s Poll-Latenz sofort `true` ist.
 * Der `EventJobRunningProvider` kombiniert dieses Flag mit dem echten Query-Status
 * und räumt es wieder ab, sobald der Job per Query bestätigt (oder die TTL erreicht) ist.
 */
class EventJobRunningStore {
  public optimisticRunning = false;

  private timeout: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    makeAutoObservable(this, { markStarted: false, clear: false });
  }

  /**
   * Markiert sofort einen gerade ausgelösten Job als laufend.
   * Sicherheits-TTL, falls der echte Status den Job nie als laufend meldet
   * (z.B. sehr kurzer oder fehlgeschlagener Job), damit das Flag nicht hängen bleibt.
   */
  markStarted(maxMs = 30000) {
    runInAction(() => {
      this.optimisticRunning = true;
    });
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.clear(), maxMs);
  }

  clear() {
    runInAction(() => {
      this.optimisticRunning = false;
    });
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }
}

export const eventJobRunningStore = new EventJobRunningStore();
